/**
 * @module components\TxnHistory
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { required, numeric, maxLength } from "vuelidate/lib/validators";
import LoaderMobile from '@/services/loaderMobile';
import sToast from '@/services/sToast';
import core from '@/services/core';
import store from '@/store';
import * as XLSX from "xlsx";
import utilities from "@/utilities";
import _ from "lodash";


@Component
export default class ManageUser extends Vue {
    page = 1;
    loading = false;
    loggedInUser = null;
    userResponse = [];
    userSearch = "";
    pageCount = 0;

    module = ['All', 'Agent', 'Customer'];
    headers = [
        { text: 'Sr.No.', value: 'srNo' },
        { text: 'User ID', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Mobile No.', value: 'mob' },
        { text: 'Email ID', value: 'email' },
        { text: 'Status', value: 'sts' },
        { text: 'Action', value: 'action' },
    ];

    created() {
        this.loggedInUser = store.getters.sessLoginDataGet;
        let request = {
            token: this.loggedInUser.sessionId,
            clientId: this.loggedInUser.clientId
        }
        this.loading = true;
        core
            .post({
                data: request,
                url: 'user/view',
                method: 'post'
            })
            .then(response => {
                this.userResponse = response['users'];
                this.addSrNum();
            })
            .catch(error => {
                this.loading = false;
            });
    }

    addSrNum() {
        this.userResponse = this.userResponse.map((a, index) => ({ ...a, srNo: index + 1 }));
    }

    addUser() {
        this.$router.push({ name: "createUser" });
    }
    editUser(user) {
        this.updateUser(user);
        this.$router.push({ name: "editUser" });
    }

    updateUser(user) {
        let users = { updateUser: user };
        store.dispatch("updateManageUserAc", users);
    }

    getClass(code) {
        let classStr = "";
        if (code == 'DEACTIVE') {
            classStr = 'deactive-txt'
        } else if (code == 'PENDING') {
            classStr = 'pending-txt'
        }
        return classStr;
    }
}
